import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Detects if the user is on an iOS device (iPhone, iPad, iPod)
 * Only detects actual iOS devices, not Desktop Safari
 * @returns true if the device is running iOS
 *
 * @deprecated - Use useIsIOS() hook instead for memoized detection
 * This function is kept for backward compatibility but no longer logs
 */
export function isIOS(): boolean {
  if (typeof window === 'undefined') return false;
  const ua = navigator.userAgent;

  // Only check for actual iOS devices (iPhone, iPad, iPod)
  // Do NOT check for Safari alone, as Desktop Safari would be incorrectly detected
  return /iphone|ipad|ipod/i.test(ua);
}
